module.exports = __webpack_public_path__ + "static/media/image_54.a108ec6b.png";